<template>
  <div>
    <v-card @click="openInteractionsDialog()" flat class="pa-0 ma-0">
      <v-row align="center" justify="center" class="pa-0 ma-0 vetalfa-row">
        <v-icon size="26" color="primary">{{
          _icon("drugsInteractions")
        }}</v-icon>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import images from "@/constants/images.js";
export default {
  name: "DrugsInteractionsButton",
  computed: {},
  props: {},
  methods: {
    ...mapActions("general", ["logEvent", "routePathRedirect"]),
    openInteractionsDialog() {
      this.logEvent("interactions_btn_click");
      this.routePathRedirect({ path: "/drugs/interactions?hasDrug=true" });
    },
  },
  data() {
    return {
      interactions: images.INTERACTIONS,
    };
  },
};
</script>